import { lazy } from 'react';

const PublicSurveyPage = lazy(() => import('src/pages/public/survey'));

/**
 * The only route a signed-out visitor is meant to reach. No AuthGuard, because the voter has
 * no account, and no GuestGuard either: that would bounce a signed-in manager to the dashboard
 * when they open their own task's link to check it.
 */
export const publicSurveyRoutes = [
  {
    path: 's/:token',
    element: <PublicSurveyPage />,
  },
];
